import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { DeacParamList } from '../../../typings/Params';
import { useAuth } from '../../../context/Auth';
import ActingBodiesDropdown from '../../../components/Dropdowns/ActingBodiesDropdown';
import ActingBodiesUnitsDropdown from '../../../components/Dropdowns/ActingBodiesUnitsDropdown';
import ActingBodiesCommandsDropdown from '../../../components/Dropdowns/ActingBodiesCommandDropdown';

interface Props {
    filters: DeacParamList['Workplaces'];
    setFilters: React.Dispatch<React.SetStateAction<DeacParamList['Workplaces']>>;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<DeacParamList, 'Workplaces'>>>();
    const { user: authenticatedUser } = useAuth();

    const [actingBodyId, setActingBodyId] = useState<number>(filters.actingBodyId ?? 0);
    const [actingBodyUnitId, setActingBodyUnitId] = useState<number>(filters.actingBodyId ?? 0);
    const [actingBodyCommandId, setActingBodyCommandId] = useState<number>(filters.actingBodyId ?? 0);

    const handleCleanFilter = () => {
        setTextFilter('');
        setActingBodyId(0);
        setActingBodyUnitId(0);
        setActingBodyCommandId(0);
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
            actingBodyUnitId: actingBodyUnitId !== 0 ? actingBodyUnitId : undefined,
            actingBodyCommandId: actingBodyCommandId !== 0 ? actingBodyCommandId : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
            actingBodyUnitId: actingBodyUnitId !== 0 ? actingBodyUnitId : undefined,
            actingBodyCommandId: actingBodyCommandId !== 0 ? actingBodyCommandId : undefined,
        });
    };

    const getActingBodyId = () => {
        if (!authenticatedUser) {
            return 0;
        }

        if (authenticatedUser.permissions.deac_manage_all_acting_bodies_workplaces) {
            return actingBodyId;
        }
        return authenticatedUser.actingBodyUnit.actingBodyId;
    };

    if (!authenticatedUser) {
        return <></>;
    }

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />

            {authenticatedUser.permissions.deac_manage_all_acting_bodies_workplaces &&
                <ActingBodiesDropdown
                    includeAllOption={true}
                    value={actingBodyId}
                    setValue={setActingBodyId}
                    zIndex={3} />
            }

            {(authenticatedUser.permissions.deac_manage_all_acting_bodies_workplaces ||
                authenticatedUser.permissions.deac_manage_acting_body_units_workplaces)
            && <ActingBodiesUnitsDropdown
                includeAllOption={true}
                value={actingBodyUnitId}
                setValue={setActingBodyUnitId}
                actingBodyId={getActingBodyId()}
                zIndex={2}
            />
            }

            <ActingBodiesCommandsDropdown
                includeAllOption={true}
                value={actingBodyCommandId}
                setValue={setActingBodyCommandId}
                actingBodyId={getActingBodyId()}
                disabled={false}
                zIndex={1}
            />
        </Filters>
    );
}

export default Filter;
